<div class="c-modal">
    <div class="c-modal__header">
        <div class="c-modal__header--title">
            <img src="../../../../assets/madero-logo.svg" alt="" srcset="">
            <h3>Faça sua reserva!</h3>
        </div>
    </div>

    @if(notFound){
      <div class="c-finish">
        <div class="c-finish__icon">
          <span class="material-symbols-rounded icon-error"> error </span>
        </div>
        <div class="c-finish__content">
          <h1>Não encontramos o Restaurante!</h1>
          <h3>Acesse nosso site e tente novamente!</h3>
        </div>
      </div>
    }@else {

      <div class="c-tabs">
        <mat-tab-group mat-stretch-tabs="false" mat-align-tabs="start" #tabGroup [tabIndex]="indexTab">
          <mat-tab label="Dados da reserva">
            @if (hidePanels) {
              <div class="c-select-branch">
                <span class="material-symbols-rounded icon"> location_on </span>
                <h1> {{ selectedStore }}</h1>
              </div>
            }
            <form [formGroup]="formreserve">
              <div class="c-accordion">
                <mat-accordion class="c-accordion__container">
                    <!-- Estados -->
                    <mat-expansion-panel [ngClass]="hidePanels ? 'hide' : ''" [expanded]="step === 0" [disabled]="disableAccordion[0]" (opened)="setStep(0)" hideToggle>
                      <mat-expansion-panel-header>
                        <mat-panel-title>
                          Onde?
                        </mat-panel-title>
                        <mat-panel-description>
                          {{ selectedCity ? (selectedCity + '/' + selectedState) : 'Selecione...' }}
                          @if(loaderState || loaderCity){
                            <mat-spinner class="c-spinner"></mat-spinner>
                          }@else{
                            <span class="material-symbols-rounded icon"> location_on </span>
                          }
                        </mat-panel-description>
                      </mat-expansion-panel-header>

                      <mat-form-field appearance="outline">
                        <mat-label for="state">Estado</mat-label>
                        <mat-select id="state"
                                    formControlName="state"
                                    (selectionChange)="onSelectState($event)">
                                    @for (state of listState; track $index) {
                                      <mat-option [value]="state.acronym">{{ state.name }}</mat-option>
                                    }
                        </mat-select>
                        @if (formreserve.get('state')?.hasError('required')) {
                          <mat-error>Selecione um Estado.</mat-error>
                        }
                      </mat-form-field>

                      <br>

                      <mat-form-field appearance="outline">
                        <mat-label for="city">Cidade</mat-label>
                        <mat-select id="city"
                                    formControlName="city"
                                    (selectionChange)="onSelectCity($event)">
                            @for (city of listCity; track $index) {
                              <mat-option [value]="city">{{ city.name }}</mat-option>
                            }
                        </mat-select>
                        @if (formreserve.get('city')?.hasError('required')) {
                          <mat-error>Selecione uma cidade.</mat-error>
                        }
                      </mat-form-field>

                      <mat-action-row>
                        <button mat-button
                                color="primary"
                                (click)="nextStep()"
                                [disabled]="onCheckDisable('city')">Próximo</button>
                      </mat-action-row>
                    </mat-expansion-panel>

                    <!-- Restaurante -->
                    <mat-expansion-panel [ngClass]="hidePanels ? 'hide' : ''" [expanded]="step === 1" [disabled]="disableAccordion[1]" (opened)="setStep(1)" hideToggle>
                      <mat-expansion-panel-header>
                        <mat-panel-title>
                          Qual Unidade?
                        </mat-panel-title>
                        <mat-panel-description>
                          {{ selectedStore }}
                          @if(loaderStore){
                            <mat-spinner class="c-spinner" color="primary"></mat-spinner>
                          }@else{
                            <span class="material-symbols-rounded icon"> storefront </span>
                          }
                        </mat-panel-description>
                      </mat-expansion-panel-header>


                      <mat-form-field appearance="outline">
                        <mat-label for="unit">Unidade</mat-label>
                        <mat-select id="unit"
                                    formControlName="store"
                                    (selectionChange)="onSelectStore($event)">
                            @for (store of listStore; track $index) {
                              <mat-option [value]="store">{{ store.nickName }}</mat-option>
                            }
                        </mat-select>
                        @if (formreserve.get('store')?.hasError('required')) {
                          <mat-error>Selecione uma loja.</mat-error>
                        }
                      </mat-form-field>

                      <mat-action-row>
                        <button mat-button color="warn" (click)="prevStep()">Anterior</button>
                        <button mat-button color="primary" (click)="nextStep()" [disabled]="onCheckDisable('store')">Próximo</button>
                      </mat-action-row>
                    </mat-expansion-panel>

                    <!-- Salão -->
                    <mat-expansion-panel [ngClass]="showPanelHall ? '' : 'hide'" [expanded]="step === 2" [disabled]="disableAccordion[2]" (opened)="setStep(2)" hideToggle>
                      <mat-expansion-panel-header>
                        <mat-panel-title>
                          Qual o salão?
                        </mat-panel-title>
                        <mat-panel-description>
                          {{ selectedHall }}
                          @if(loaderHall){
                            <mat-spinner class="c-spinner" color="primary"></mat-spinner>
                          }@else{
                            <span class="material-symbols-rounded icon"> table_bar </span>
                          }
                        </mat-panel-description>
                      </mat-expansion-panel-header>

                      <mat-form-field appearance="outline">
                        <mat-label for="hall">Salão</mat-label>
                        <mat-select id="hall"
                                    formControlName="hall"
                                    (selectionChange)="onSelectHall($event)">
                            @for (hall of listHall; track $index) {
                              <mat-option [value]="hall">{{ hall.hallName }}</mat-option>
                            }
                        </mat-select>
                        @if (formreserve.get('hall')?.hasError('required')) {
                          <mat-error>Selecione um salão.</mat-error>
                        }
                      </mat-form-field>

                      <mat-action-row>
                          <button mat-button color="warn" (click)="prevStep()">Anterior</button>
                          <button mat-button color="primary" (click)="nextStep()" [disabled]="onCheckDisable('hall')">Próximo</button>
                      </mat-action-row>
                  </mat-expansion-panel>

                  <!-- Quantas pessoas -->
                  <mat-expansion-panel [expanded]="step === 3" [disabled]="disableAccordion[3]" (opened)="setStep(3)" hideToggle>
                    <mat-expansion-panel-header>
                      <mat-panel-title>
                        Quantas pessoas?
                      </mat-panel-title>
                      <mat-panel-description>
                        {{ selectedPeoples }}
                        @if(loaderPeoples){
                          <mat-spinner class="c-spinner" color="primary"></mat-spinner>
                        }@else{
                          <span class="material-symbols-rounded icon"> group </span>
                        }
                      </mat-panel-description>
                    </mat-expansion-panel-header>

                    <mat-form-field appearance="outline">
                      <mat-label for="people">Pessoas</mat-label>
                      <mat-select id="people"
                                  formControlName="peoples"
                                  (selectionChange)="onSelectPeople($event)">
                          @for (people of listPeoples; track $index) {
                            <mat-option [value]="people">{{ people }}</mat-option>
                          }
                      </mat-select>
                      @if (formreserve.get('peoples')?.hasError('required')) {
                        <mat-error>Selecione quantas pessoas.</mat-error>
                      }
                    </mat-form-field>

                    <mat-action-row>
                      @if(!hidePanels){
                        <button mat-button color="warn" (click)="prevStep()">Anterior</button>
                      }
                        <button mat-button color="primary" (click)="nextStep()" [disabled]="onCheckDisable('peoples')">Próximo</button>
                    </mat-action-row>
                  </mat-expansion-panel>

                    <!-- Dia da reserva -->
                    <mat-expansion-panel [expanded]="step === 4" [disabled]="disableAccordion[4]" (opened)="setStep(4)" hideToggle>
                      <mat-expansion-panel-header>
                        <mat-panel-title>
                            O Dia da reserva
                        </mat-panel-title>
                        <mat-panel-description>
                          {{ selectedDay !== '' ? (selectedDay | date: 'dd/MM/yyyy' ) : 'Selecione...' }}
                          @if(loaderDay){
                            <mat-spinner class="c-spinner" color="primary"></mat-spinner>
                          }@else{
                            <span class="material-symbols-rounded icon"> event </span>
                          }
                        </mat-panel-description>
                      </mat-expansion-panel-header>

                      <mat-form-field appearance="outline">
                        <mat-label>Data da reserva</mat-label>
                        <input matInput
                              [matDatepicker]="picker"
                              (focus)="picker.open()"
                              readonly
                              formControlName="day"
                              [matDatepickerFilter]="dateFilter"
                              (dateChange)="onSelectDay($event)">
                        @if (formreserve.get('day')?.hasError('required')) {
                          <mat-error>Selecione um dia.</mat-error>
                        }
                      </mat-form-field>
                      <mat-datepicker #picker dateFormat="dd/MM/yyyy"></mat-datepicker>

                      <mat-action-row>
                        <button mat-button color="warn" (click)="prevStep()">Anterior</button>
                        <button mat-button color="primary" (click)="nextStep()" [disabled]="onCheckDisable('day')">Próximo</button>
                      </mat-action-row>
                    </mat-expansion-panel>

                    <!-- Qual o horário -->
                    <mat-expansion-panel [expanded]="step === 5" [disabled]="disableAccordion[5]" (opened)="setStep(5)" hideToggle>
                      <mat-expansion-panel-header>
                        <mat-panel-title>
                          Qual o horário?
                        </mat-panel-title>
                        <mat-panel-description>
                          {{ selectedHour }}
                          @if(loaderHour){
                            <mat-spinner class="c-spinner" color="primary"></mat-spinner>
                          }@else{
                            <span class="material-symbols-rounded icon"> alarm </span>
                          }
                        </mat-panel-description>
                      </mat-expansion-panel-header>

                      @if(listHour.length < 1){
                        <h3>Não existem horários disponíveis para esta data! Selecione outra data.</h3>
                      }@else{
                        <mat-form-field appearance="outline">
                          <mat-label for="time">Horário</mat-label>
                          <mat-select id="time"
                                      formControlName="hour"
                                      (selectionChange)="onSelectHour($event)">
                              @for (hour of listHour; track $index) {
                                <mat-option [value]="hour">{{ hour }}</mat-option>
                              }
                          </mat-select>
                          @if (formreserve.get('hour')?.hasError('required')) {
                            <mat-error>Selecione um horário.</mat-error>
                          }
                        </mat-form-field>
                      }

                      <mat-action-row>
                          <button mat-button color="warn" (click)="prevStep()">Anterior</button>
                          <button mat-button color="primary" (click)="onGoNext(indexTab == 0 ? 1 : 2)" [disabled]="onCheckDisable('hour')">Continuar</button>
                      </mat-action-row>
                  </mat-expansion-panel>

                </mat-accordion>
              </div>
            </form>
          </mat-tab>
          <mat-tab label="Dados de usuário">
            <div class="c-modal__content">
              <form [formGroup]="form">

                <mat-form-field appearance="outline">
                  <mat-label>CPF</mat-label>
                  <input (blur)="onBlur($event)" matInput mask="000.000.000-00" hamburger="CPF..." formControlName="cpf" />
                  <mat-icon matSuffix color="primary">how_to_reg</mat-icon>
                  @if (form.get('cpf')?.hasError('required')) {
                    <mat-error>Insira seu cpf</mat-error>
                  }
                  @if (form.get('cpf')?.hasError('invalidCpf')) {
                    <mat-error>CPF inválido</mat-error>
                  }
                </mat-form-field>

                <mat-form-field appearance="outline">
                  <mat-label>Nome</mat-label>
                  <input matInput hamburger="Nome..." formControlName="name" />
                  <mat-icon matSuffix color="primary">account_circle</mat-icon>

                  @if (form.get('name')?.hasError('required')) {
                    <mat-error>Insira seu Nome</mat-error>
                  }
                </mat-form-field>

                <mat-form-field appearance="outline">
                  <mat-label>E-mail</mat-label>
                  <input matInput hamburger="Email..." formControlName="mail" />
                  <mat-icon matSuffix color="primary">alternate_email</mat-icon>

                  @if (form.get('mail')?.hasError('required')) {
                    <mat-error>Insira seu e-mail</mat-error>
                  }
                  @if (form.get('mail')?.hasError('email')) {
                    <mat-error>Coloque um e-mail válido</mat-error>
                  }
                  @if (form.hasError('required')) {
                    <mat-error>Insira seu <strong>usuário.</strong></mat-error>
                  }
                </mat-form-field>

                <mat-form-field appearance="outline">
                  <mat-label>Celular</mat-label>
                  <input matInput mask="(00) 00000-0000" hamburger="Celular..." formControlName="phone" />
                  <mat-icon matSuffix color="primary">phone</mat-icon>

                  @if (form.get('mail')?.hasError('required')) {
                    <mat-error>Insira seu Celular</mat-error>
                  }
                </mat-form-field>

                <mat-form-field appearance="outline">
                  <mat-label>Data de nascimento</mat-label>
                  <input matInput mask="00/00/0000" hamburger="Data de nascimento..." formControlName="birthday" />
                  <mat-icon matSuffix color="primary">cake</mat-icon>

                  @if (form.get('birthday')?.hasError('required')) {
                    <mat-error>Insira sua Data de nascimento</mat-error>
                  } @else if (form.get('birthday')?.hasError('invalidAgeRange')) {
                    <mat-error>A idade deve estar entre 16 e 130 anos</mat-error>
                  } @else if (form.get('birthday')?.hasError('invalidDayOfMonth')) {
                    <mat-error>Data Inválida</mat-error>
                  }
                </mat-form-field>

                <mat-form-field appearance="outline">
                  <mat-label for="occasion">Ocasião</mat-label>
                  <mat-select id="occasion"
                              formControlName="occasion">
                      @for (ocasion of listOcasions; track $index) {
                        <mat-option [value]="ocasion.id">{{ ocasion.name }}</mat-option>
                      }
                  </mat-select>
                  <mat-icon matSuffix color="primary">star_border</mat-icon>

                  @if (form.get('mail')?.hasError('required')) {
                    <mat-error>Insira a Ocasião</mat-error>
                  }
                </mat-form-field>

                <mat-form-field appearance="outline">
                  <mat-label>Observação</mat-label>
                  <input maxlength="100" matInput hamburger="Observação..." formControlName="observation" />
                  <mat-icon matSuffix color="primary">comment</mat-icon>

                  @if (form.get('mail')?.hasError('required')) {
                    <mat-error>Insira a Observação</mat-error>
                  }
                </mat-form-field>

                <p>Essa solicitação está sujeita a disponibilidade do restaurante.</p>

                <mat-checkbox color="primary" class="example-margin">Aceito receber conteúdos publicitários do Madero, via email e celular fornecidos por mim.</mat-checkbox>

                <p class="policies">Ao reservar, você também declara que aceita os <a href="/terms" target="_blank">termos</a> e <a href="/policies" target="_blank">políticas</a> do Madero. </p>

              </form>
          </div>
          </mat-tab>
          <mat-tab label="Conclusão">
            <div class="c-finish">
              <div class="c-finish__icon">
                <img src="../../../../assets/images/avatar.png" alt="" srcset="">
              </div>
              <div class="c-finish__content">
                <h1>Olá, <b>{{ bodyReservation.name }}</b></h1>
                <h3>sua reserva foi recebida!</h3>
                <div class="c-resume">
                  <p>Estaremos te esperando no</p>
                  <p class="c-resume__store">{{ selectedStore }}</p>
                  <p class="c-resume__date">
                    <span class="material-symbols-rounded icon"> date_range </span>{{ formatDatePtBR(bodyReservation.date) }} -
                    <span class="material-symbols-rounded icon"> access_alarm </span>{{ bodyReservation.hour }}
                  </p>
                  <p>com reserva para <b>{{ bodyReservation.quantity }}</b> pessoas no <b>{{ selectedHall }}</b> </p>
                  <p>O tempo de tolerância é de, <b>{{ branchTolerance }} minutos</b></p>
                </div>
              </div>
              <div class="c-alert">
                <span class="material-symbols-rounded icon"> thumb_up_alt </span>
                <p class="c-alert__message">Não se esqueça de confirmar sua reserva pelo e-mail. Caso não receba, consulte sua caixa de spam.</p>
              </div>
            </div>
          </mat-tab>
        </mat-tab-group>
      </div>

      <div class="c-modal__footer">
          <button mat-raised-button
                class="c-modal__footer--btn"
                (click)="prevTab()"
                [hidden]="indexTab == 0 || indexTab > 1">
                    <span>Voltar</span>
          </button>
          <button mat-raised-button
                  class="c-modal__footer--btn"
                  (click)="onGoNext(indexTab == 0 ? 1 : 2)"
                  [disabled]="!onValidateForms() || loading"
                  [hidden]="indexTab > 1">
                  @if (loading) {
                    <div class="c-btn-spinner">
                      <mat-spinner class="c-btn--spinner"></mat-spinner>
                      <span>Carregando...</span>
                    </div>
                  } @else {
                    <span>{{ indexTab == 0 ? 'Continuar' : 'Reservar' }}</span>
                  }

          </button>
      </div>
    }
</div>
